import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import BingoGenerator from './views/BingoGenerator'

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/bingo',
            name: 'BingoGenerator',
            component: BingoGenerator
        }


    ]
})
